export function formatVatCondition(vatCondition: string) {
  const spaced = vatCondition.replaceAll('_', ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
